import "./script/main"
import './script/glitch'
import "./style/base/style.sass"
import './script/slider'
import '../node_modules/swiper/swiper.scss'
import '../node_modules/swiper/components/pagination/pagination.scss'
import '../node_modules/animate.css/source/fading_entrances/fadeIn.css'
import 'aos/dist/aos'
import 'aos/dist/aos.css'
import 'parallax-js'
import 'vanilla-tilt'
import 'smooth-scrollbar'